import Vue from 'vue';
import ElementUI from 'element-ui';
import axios from 'axios';
import vueRx from 'vue-rx';
import * as Rx from 'rxjs';

import App from './App.vue';
import router from './router/router';
import store from './store/store';
import locale from 'element-ui/lib/locale/lang/ja';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

// ==================== Calendar
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';

Vue.use(VCalendar, {
  firstDayOfWeek: 1,
  locale: 'ja',
  popoverDirection: 'bottom',
  popoverAlign: 'top',
  popoverVisibility: 'focus',
  maxTapTolerance: 10,
  popoverKeepVisibleOnInput: true,
});
// ==================== Calendar

axios.defaults.baseURL = '';
Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });
Vue.use(vueRx, Rx);
Vue.component("v-select", vSelect);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
